import { Component, input, signal, TemplateRef, inject, contentChild } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { AppButtonComponent } from '@htx/core';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
  selector: 'app-introduction-box',
  imports: [TranslocoPipe, AppButtonComponent, NgClass, NgTemplateOutlet],
  templateUrl: './introduction-box.component.html',
  styleUrl: './introduction-box.component.scss'
})
export class IntroductionBoxComponent {
  readonly localStorageService = inject(LocalStorageService);
  readonly storageKey = 'introduction-box';
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly hidable = input<boolean>(false);
  readonly imageSrc = input.required<string>();
  readonly imageAlt = input.required<string>();

  hidden = signal(false);
  readonly contentTpl = contentChild(TemplateRef);

  constructor() {
    this.loadState();
  }

  buttonHide() {
    if (this.hidable()) {
      this.hidden.update(this.hidden() ? () => false : () => true);
      this.saveState();
    }
  }

  saveState(): void {
    const state = { hidden: this.hidden() };
    this.localStorageService.setItem(this.storageKey, state);
  }

  loadState(): void {
    const state = this.localStorageService.getItem<{ hidden: boolean }>(this.storageKey);
    this.hidden.set(state?.hidden ?? false);
  }
}
